<template>
  <div id="container">
    <!-- 进度条区域开始-->
    <div id="gauge-content">
      <dv-border-box-7>
      <div id="planChart" ref="planChart_ref"></div>
      </dv-border-box-7>
    </div>

    <!-- 进度条区域结束-->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
    export default {
        name: "ScwlWaybillMonthChartOther",
      computed: {
        ...mapState('bigScreenData', ['waybillMonthList'])
      },
      watch: {
        waybillMonthList (val, old) {
          var plan_data1 = [];
          var plan_data2 = [];
          var plan_xAxis = [];
          for (let li of val) {
            plan_xAxis.push(li.distributionMonth);
            plan_data1.push(li.waybillCount);
            plan_data2.push(li.waybillCount);
          }
          this.planOption.xAxis.data = plan_xAxis;
          this.planOption.series[0].data = plan_data1;
          this.planOption.series[1].data = plan_data2;

          this.planChart = this.$echarts.init(this.$refs.planChart_ref)

          this.planChart.setOption(this.planOption)

        },
      },
        data(){
            return {
                planChart:null,
                planOption:{
                    xAxis: {
                        data: null,
                        axisLabel: {
                            textStyle: {
                                color: '#B7E1FF',
                                fontSize: 10
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#09F'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#09F'
                            }
                        }
                    },
                    yAxis: {
                        inverse: false,
                        splitArea: {show: false},
                        axisLine: {show: false},
                        axisTick: {show: false},
                        axisLabel: {
                            textStyle: {
                                color: '#B7E1FF',
                                fontSize: 10,
                                fontFamily: 'Arial',
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#09F'
                            }
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        textStyle: {
                            color: '#FFF',
                            fontSize: 10
                        }
                    },
                    grid: {
                        left: 50,
                        right:20,
                    },
                    legend: {
                        // show: false,
                        top: 'top',
                        textStyle: {
                            color: '#fffff1',
                            fontSize: 10
                        },
                        data: ['月度订单']
                    },
                    series: [
                        {
                            name: '月度订单',
                            type: 'bar',
                            itemStyle:
                                {
                                    normal: {color: '#2499F4'},
                                    emphasis: {color: '#2499F8'}
                                },
                            barWidth: 18,
                            data: null
                        },
                        {
                            name: '月度订单量',
                            type: 'line',
                            itemStyle: {
                                normal: {
                                    color: '#F90',
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            color: '#CCC',
                                            fontSize: 10
                                        }
                                    },
                                    lineStyle: {
                                        color: '#F90',
                                        width: 2
                                    }
                                },
                                emphasis: {
                                    color: '#FF0'
                                }
                            },
                            symbolSize: 8,
                            data: null
                        }
                    ]
                }
            }
        },
        created() {
        },
        mounted() {
            this.initChart()
        },
        methods: {
            async initChart() {
            }
        }
    }
</script>

<style scoped>
  #container {

  }

  #gauge-content {
    color:#E1E1E1;
    width: 98%;
    box-sizing: border-box;
    height: 94%;
    /*overflow: hidden;*/
    /*border: 1px solid beige;*/
    margin-left: 20px;
    align-content: center;
  }

  #planChart {
    width: 100%;
    height: 280px;
  }
</style>
